import { render, staticRenderFns } from "./qualification-result-nbn.vue?vue&type=template&id=57e1ceb3&scoped=true"
import script from "./qualification-result-nbn.vue?vue&type=script&lang=js"
export * from "./qualification-result-nbn.vue?vue&type=script&lang=js"
import style0 from "./qualification-result-nbn.vue?vue&type=style&index=0&id=57e1ceb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1ceb3",
  null
  
)

export default component.exports